module.exports = __webpack_public_path__ + "static/media/reports.db476808.svg";